import { PageSeo } from '@/components/seo/PageSeo'
import { BookCallButton } from '@/components/ui/Button'
import { faqGroups, faqItems, faqUpdated } from '@/config/faq'
import { sitePages } from '@/config/pages'
import { siteConfig } from '@/config/site'
import { faqPageJsonLd } from '@/lib/seo'

/* The FAQ, set like About: each group is a row with its label on the left and the questions on the
   right. Every answer is in the page, never behind a click, so crawlers that don't run script read
   it all, and the structured data repeats the same words. */

const faqSchema = faqPageJsonLd(
  sitePages.faq.path,
  faqItems.map((item) => ({ question: item.question, answer: item.answer.join(' ') })),
)

/** A paragraph of an answer, with the site's email address as a link. */
const AnswerText = ({ text }: { text: string }) => {
  const parts = text.split(siteConfig.email)

  return parts.flatMap((part, index) =>
    index === 0
      ? [part]
      : [
          <a key={index} href={`mailto:${siteConfig.email}`}>
            {siteConfig.email}
          </a>,
          part,
        ],
  )
}

export const FaqPage = () => (
  <>
    <PageSeo page={sitePages.faq} jsonLd={[faqSchema]} />
    <div className="a2">
      <div className="nav-space" aria-hidden="true" />
      <div className="x-wrap">
        <section className="a2-row a2-row--top" aria-labelledby="faq-title">
          <p className="x-eyebrow x-eyebrow--ink a2-label">FAQ</p>
          <div className="a2-copy">
            <h1 id="faq-title" className="a2-title">
              Frequently asked questions
            </h1>
            <p className="a2-text a2-text--lead">
              Answers to what accounting firm owners ask us most: the deal, Justine, your team and clients, and how to start.
            </p>
            <p className="faq-updated">Last updated {faqUpdated}</p>
          </div>
        </section>

        {faqGroups.map((group) => (
          <section key={group.id} id={group.id} className="a2-row" aria-labelledby={`${group.id}-title`}>
            <h2 id={`${group.id}-title`} className="x-eyebrow x-eyebrow--ink a2-label faq-label">
              {group.title}
            </h2>
            <div className="a2-copy faq-list">
              {group.items.map((item) => (
                <div key={item.id} id={item.id} className="faq-item">
                  <h3>{item.question}</h3>
                  {item.answer.map((paragraph) => (
                    <p key={paragraph} className="a2-text">
                      <AnswerText text={paragraph} />
                    </p>
                  ))}
                  {item.bookCall ? <BookCallButton className="faq-btn" /> : null}
                </div>
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  </>
)
